import _ from "lodash";
import TableReportHelper from "report/helper";

export default async function tipoIndicadorReport(TipoClass, visita) {
    const h = new TableReportHelper(visita.data);
    const content = [];
    const apontamentos = visita.getApontamentosByTipo(TipoClass);

    if (!_.isEmpty(apontamentos)) {
        for (const IndicadorClass of TipoClass.indicadores) {
            const indicador = new IndicadorClass(TipoClass);
            try {
                await indicador.renderReport(visita);
            } catch (error) {
                console.log("ERROR!!! ", error);
                console.log("Erro no indicador : ", indicador.constructor.name);
                throw new Error("Indicador : " + indicador.constructor.name + "\n" + error.message + "\n" + error);
            }
        }

        content.push(
            h.panel([
                // prettier-ignore
                h.row(
                    h.title(TipoClass.fullName, { fontSize: 12, alignment: "center" })
                ),
            ])
        );

        for (const IndicadorClass of TipoClass.indicadores) {
            const indicador = new IndicadorClass(TipoClass);
            let ind = await indicador.renderReport(visita)

            content.push(ind);
        }
    }

    return content;
}
